export default function gtag(...p) {
	if (typeof (window !== "undefined") && window.gtag) {
		window.gtag(...p);
	}
}
